import { useState, useEffect } from 'react';
import { WifiOff, Wifi } from 'lucide-react';

/**
 * Toont een banner bovenaan de app zodra het browser-online event zegt dat
 * we offline zijn. Verdwijnt weer zodra we online komen. Werkt samen met de
 * service worker (sw.js v4) die dan gecachte data uitserveert.
 */
export default function OfflineBanner() {
  const [online, setOnline] = useState(typeof navigator !== 'undefined' ? navigator.onLine : true);
  const [justCameBack, setJustCameBack] = useState(false);

  useEffect(() => {
    const goOffline = () => setOnline(false);
    const goOnline = () => {
      setOnline(true);
      setJustCameBack(true);
      setTimeout(() => setJustCameBack(false), 3000);
    };
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  if (online && !justCameBack) return null;

  return (
    <div
      className={`fixed top-0 left-0 right-0 z-[100] px-4 py-2 text-sm font-medium shadow-md ${
        online ? 'bg-emerald-600 text-white' : 'bg-amber-500 text-amber-950'
      }`}
      data-testid="offline-banner"
      role="status"
    >
      <div className="max-w-6xl mx-auto flex items-center gap-2">
        {online ? (
          <>
            <Wifi className="w-4 h-4" />
            <span>Verbinding hersteld — je wijzigingen worden nu gesynchroniseerd</span>
          </>
        ) : (
          <>
            <WifiOff className="w-4 h-4" />
            <span>
              Geen internet — je werkt in <strong>offline modus</strong>. Nieuwe
              invoer wordt opgeslagen en verstuurd zodra je weer verbinding hebt.
            </span>
          </>
        )}
      </div>
    </div>
  );
}
